import { EARTH_RADIUS_KM } from "./constants";

import {
  Color,
  TextureLoader,
} from 'three';
import Globe from 'globe.gl';

export class GlobeVisualization {

  constructor({widget, showEarth=true, backgroundColor='black', stars=false}){

    this.globeDOM = document.createElement("div");
    widget.DOMElement.appendChild(this.globeDOM);

    this.world = Globe()
    (this.globeDOM)
    .globeImageUrl('//unpkg.com/three-globe/example/img/earth-blue-marble.jpg')
    .bumpImageUrl('//unpkg.com/three-globe/example/img/earth-topology.png')
    .backgroundColor(backgroundColor);

    if(stars){
      this.world.backgroundImageUrl('//unpkg.com/three-globe/example/img/night-sky.png');
    }

    const globeMaterial = this.world.globeMaterial();
    globeMaterial.bumpScale = 10;
    new TextureLoader().load('//unpkg.com/three-globe/example/img/earth-water.png', texture => {
      globeMaterial.specularMap = texture;
      globeMaterial.specular = new Color('grey');
      globeMaterial.shininess = 15;
    });

    setTimeout(() => { // wait for scene to be populated (asynchronously)
      const directionalLight = this.world.scene().children.find(obj3d => obj3d.type === 'DirectionalLight');
      directionalLight && directionalLight.position.set(1, 1, 1); // change light position to see the specularMap's effect
    });

    if (!showEarth) {
      this.world.showGlobe(false).showAtmosphere(false);
    }

    widget.addResizeHandler(this.resizeHandler.bind(this));
    widget.resize(0);

  }

  resizeHandler(width, height){
    this.world.width([width]);
    this.world.height([height]);
  }


  outlineGeoJSON(geometry){

    var lines = structuredClone(geometry);
    var lines2 = [];
    lines.forEach(line => {
      lines2.push(line[0]);
      line[0].forEach(pt => {
        pt = pt.reverse();
      })
    });
    this.world.pathsData(lines2)
    .pathColor(() => ['rgba(128,0,128,1.0)', 'rgba(128,0,128,1.0)'])
    .pathPointAlt(15 / EARTH_RADIUS_KM).
    pathStroke(3);

  }

}